<div class="elcia-loader" *ngIf="loader">
  <ng-casto-loader></ng-casto-loader>
</div>

<div id="elciaContainer"></div>
